import Image from '../../../components/Image/Image';
import Link from '../../../components/Link/Link';

function NotFoundErrorPageBody(): JSX.Element {
  return (
    <div className='error-page__body'>
      <div className='error-page__heading'>
        <h1>Looks like this page is Permanently gone.</h1>
        <Image
          classes='error-page__image'
          alt='page not found image'
          name='not-found.svg'
          width='76'
          height='100'
        />
      </div>

      <p>
        Head back to our website or{' '}
        <Link href='https://www.newcastlepermanent.com.au/contact-us'>
          get in touch
        </Link>{' '}
        for help.
      </p>

      <Link
        href='https://www.newcastlepermanent.com.au/'
        className='underline-reversed btn btn__primary'
      >
        Go to website
      </Link>
    </div>
  );
}

export default NotFoundErrorPageBody;
